import BrokenImageIcon from '@mui/icons-material/BrokenImage'
import { Tooltip } from '@mui/material'
import React, { useState } from 'react'
import LazyLoad from 'react-lazy-load'
import config from '../../config.json'
import CollectionHeader from '../assetpreview/CollectionHeader'
import Link from '../common/util/input/Link'
import MarkDown from '../markdown/MarkDown'
import { useTheme } from 'next-themes'

const CraftPreview = (props) => {
    const { theme } = useTheme()
    const craft = props['craft']
    const index = props['index']
    const [tryVideo, setTryVideo] = useState(null)

    const { craftId, collection, displayData } = craft

    const { collectionName, verification, blacklisted } = collection

    const imgSrc = displayData.previewImg
        ? displayData.previewImg.startsWith('http')
            ? ''
            : config.ipfspreviewhash
                  .replace('{collection}', collectionName)
                  .replace('{hash}', displayData.previewImg.trim())
                  .replace('{size}', 240)
        : null
    const videoSrc = displayData.previewVideo
        ? displayData.previewVideo.startsWith('http')
            ? ''
            : config.ipfspreviewhash
                  .replace('{collection}', collectionName)
                  .replace('{hash}', displayData.previewVideo.trim())
                  .replace('{size}', 240)
        : null

    const DESCRIPTION_COLLAPSED_MAXLENGHT = 300

    const getCraftDescriptionText = () => {
        if (!displayData || !displayData.description) {
            return ''
        }

        if (displayData.description.length > DESCRIPTION_COLLAPSED_MAXLENGHT) {
            return (
                <Link href={`/craft/${craftId}`}>
                    <div className="p-5">
                        <MarkDown
                            text={
                                displayData.description.substring(
                                    0,
                                    DESCRIPTION_COLLAPSED_MAXLENGHT,
                                ) + '...'
                            }
                        />
                        <div className="mt-3 text-base text-right cursor-pointer text-primary hover:underline">
                            ...view complete description
                        </div>
                    </div>
                </Link>
            )
        } else {
            return (
                <Link href={`/craft/${craftId}`}>
                    <div className="p-5">
                        <MarkDown text={displayData.description} />
                    </div>
                </Link>
            )
        }
    }

    return (
        <LazyLoad>
            <div
                id={'AssetPreview_' + index}
                className="hover:shadow-xl shadow-lg dark:shadow rounded-lg"
            >
                <Link href={`/craft/${craftId}`} className={'group'}>
                    <div
                        className={
                            'bg-gradient-to-b from-black via-[#000000e8] rounded-t-lg'
                        }
                    >
                        <Tooltip
                            leaveDelay={100}
                            placement="right"
                            arrow
                            enterDelay={500}
                            enterNextDelay={500}
                            disableTouchListener
                            componentsProps={{
                                tooltip: {
                                    sx: {
                                        borderRadius: '1rem',
                                        backgroundColor:
                                            theme === 'light'
                                                ? 'white'
                                                : '#141414FA',
                                    },
                                },
                            }}
                            title={
                                displayData && displayData.description
                                    ? getCraftDescriptionText()
                                    : null
                            }
                        >
                            <div className=" h-64 sm:h-80 m-auto w-full p-2">
                                {displayData.previewImg && tryVideo === null ? (
                                    <img
                                        src={imgSrc}
                                        className="my-auto object-contain w-full h-full"
                                        key={imgSrc}
                                        alt={displayData.name}
                                        onError={() => setTryVideo(true)}
                                    />
                                ) : videoSrc ||
                                  (displayData.previewImg && tryVideo) ? (
                                    <img
                                        src={videoSrc}
                                        className="my-auto object-contain w-full h-full"
                                        key={videoSrc}
                                        alt={displayData.name}
                                        onError={() => setTryVideo(true)}
                                    />
                                ) : (
                                    <div className="h-20">
                                        <BrokenImageIcon color="primary" />
                                    </div>
                                )}
                            </div>
                        </Tooltip>
                    </div>
                </Link>

                <div className="w-full px-3 py-3 dark:bg-paper h-28 sm:h-32 rounded-b-lg">
                    <div className="flex justify-center font-bold md:font-semibold text-base">
                        {displayData && displayData.name ? (
                            displayData.name.length > 30 ? (
                                <Tooltip title={displayData.name}>
                                    <p>
                                        {displayData.name.substring(0, 25) +
                                            '...'}
                                    </p>
                                </Tooltip>
                            ) : (
                                displayData.name
                            )
                        ) : (
                            craft.craftId
                        )}
                    </div>

                    <div className="w-full justify-center">
                        <CollectionHeader
                            author={collectionName}
                            verified={verification}
                            blacklisted={blacklisted}
                            baseStyle="justify-center"
                        />
                    </div>

                    <div className="mt-2">
                        <p className="text-center font-semibold text-base text-primary">
                            <span className="">Crafted:</span>{' '}
                            {craft.numCrafted} / {craft.total}
                        </p>
                    </div>
                </div>
            </div>
        </LazyLoad>
    )
}

export default CraftPreview
